import { Modal, Text } from '@nimbus-ds/components';
import { CancelAndConfirmButtons, Stack } from 'commons/components';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';

interface ErrorOnLoadModalProps {
  onRetryError: () => void;
  onClose: () => void;
}

function ErrorOnLoadModal({
  onRetryError,
  onClose,
}: Readonly<ErrorOnLoadModalProps>): JSX.Element {
  const t = useTranslationShipping();
  return (
    <>
      <Modal.Header title={t('locations.deleteSteps.errorOnLoad.title')} />
      <Modal.Body padding="none">
        <Text>{`${t('locations.deleteSteps.errorOnLoad.description')}`}</Text>
      </Modal.Body>
      <Modal.Footer>
        <Stack spacing="base" justify="flex-end">
          <CancelAndConfirmButtons
            onCancel={onClose}
            onConfirm={onRetryError}
            confirmText={t('locations.errorResults.action')}
          />
        </Stack>
      </Modal.Footer>
    </>
  );
}

export default ErrorOnLoadModal;
